export const MIN_DATE = new Date(1800, 0, 1);
export const MAX_DATE = new Date(2100, 0, 1);
